import { NewArrivalsPage } from '../pages/NewArrivalsPage';

export function ResponsiveNewArrivalsPage() {
  return <NewArrivalsPage />;
}
